<template>
  <div id="app">
    <div class="branding">
      <div class="title">Matchup Machine</div>
      <div class="subtitle">
        Created by <a href="https://www.pivotanalysis.com" class="brand">Pivot Analysis</a> &middot;
        Check Out <a href="https://www.pivotanalysis.app" class="brand">The Pivot App</a>
      </div>
    </div>
    <h3>Pivot Analysis has shut down and the Matchup Machine is no longer available.</h3>
    <div class="footer">
      <img src="./assets/logo.png" />
    </div>
  </div>
</template>

<script>
import 'vue-select/src/scss/vue-select.scss';

export default {
  name: 'app',
  components: {
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fafafa;
  margin: 0;
  height: 100%;

  .branding {
    padding-top: 3rem;
    padding-bottom: 5rem;

    p {
      opacity: 0.8;
    }

    .brand {
      font-weight: bold;
    }

    a {
      color: white;

      &:visited, &:hover, &:active {
        color: white;
      }

      &:hover {
        color: $gold;
      }
    }

    .subtitle {
      font-size: 1.5em;
      opacity: 0.8;
      font-weight: lighter;
    }

    .title {
      font-size: 6em;
      font-weight: bolder;
      font-family: 'Bungee Shade', Courier, monospace;
    }
  }

  .footer {
    img {
      height: 16rem;
      width: auto;
      position: absolute;
      right: 2rem;
      top: 2rem;
      opacity: 0.2;
      z-index: 0;
    }
  }
}

body {
  background-color: rgba(0, 0, 0, 0.8);
  margin: 0;
}

html, body {
  height: 100%;
  width: 100%;
  background: url('../public/background.png') no-repeat center center fixed;
  background-size: cover;
}

input, select, textarea {
  color: map_get($vs-colors, 'darkest');
}
</style>
